import { Button } from 'antd';
import styled from 'styled-components';

interface ConsolidationButtonProps {
	$freeze?: boolean;
}

const BLUE = '#2F54EB';
const WHITE = '#FFFFFF';
const GREY_150 = '#E6E6E6';
const GREY_500 = '#262626';

export const CustomButton = styled(Button)`
	height: 40px;
	font-size: 1rem;
	width: max-content;
	padding-left: 1rem;
	padding-right: 1rem;
	border-radius: 0.2rem;

	span {
		font-weight: 600;
	}
`;

export const DownloadButton = styled(CustomButton)`
	color: ${BLUE};
	height: 40px;
	font-size: 1rem;
	border: 1px solid ${BLUE};

	&:hover {
		color: ${BLUE};
		border: 1px solid ${BLUE};
	}
`;

export const ConsolidationButton = styled(CustomButton)<ConsolidationButtonProps>`
	height: 40px;
	font-size: 1rem;
	color: ${({ $freeze }) => ($freeze ? '#828282' : '#17a93b')};
	border: 1px solid ${({ $freeze }) => ($freeze ? '#828282' : '#17a93b')};

	&:hover {
		color: ${({ $freeze }) => ($freeze ? '#828282' : '#17a93b')};
		border: 1px solid ${({ $freeze }) => ($freeze ? '#828282' : '#17a93b')};
	}

	&:focus {
		color: ${({ $freeze }) => ($freeze ? '#828282' : '#17a93b')};
		border: 1px solid ${({ $freeze }) => ($freeze ? '#828282' : '#17a93b')};
	}
`;

const BASE_BUTTON = `
	width: 100%;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	border-radius: 4px;
	font-style: normal;
	letter-spacing: -0.08px;
	height: 40px !important;
`;

export const ButtonWrapper = styled(Button)`
	${BASE_BUTTON}
`;

export const PrimaryButton = styled(Button)`
	${BASE_BUTTON}
	background-color: ${BLUE};
`;

export const GhostButton = styled(Button)`
	${BASE_BUTTON}
	color: ${GREY_500};
	background-color: ${WHITE};
	border: 1px solid ${GREY_150};
`;
